import { memo } from 'react'
import { SxProps } from '@mui/material'
import { Link } from 'react-router-dom'

import { Box } from '@/components/Layout'
import { Text } from '@/components/Data'
import Popper from '@/components/Surface/Popper'
import { partnersNavigationData } from '@/assets'

import { partnerListStyles as styles } from './Partners.styles'

interface PartnersProps {
  anchorEl: HTMLElement | null
}

const Partners = ({ anchorEl }: PartnersProps) => {
  return (
    <Popper open sx={styles.container} anchorEl={anchorEl} placement="bottom-start">
      {partnersNavigationData.map((partner) => (
        <Link key={partner.name} to={partner.link}>
          <Box sx={styles.partnerListItem}>
            <Box sx={[styles.colorBar, { backgroundColor: partner.primaryColor }] as SxProps} />
            <Text sx={styles.partnerName}>{partner.name}</Text>
          </Box>
        </Link>
      ))}
    </Popper>
  )
}

export default memo(Partners)
